import React, { useState, useCallback } from 'react';
import { surveyConfig, SURVEY_UNLOCK_KEY_PREFIX } from './config';
import './survey.css';

interface SurveyPasswordGateProps {
  surveySlug: keyof typeof import('./config').surveyConfig;
  children: React.ReactNode;
  title?: string;
}

export const SurveyPasswordGate: React.FC<SurveyPasswordGateProps> = ({
  surveySlug,
  children,
  title = 'Survey',
}) => {
  const storageKey = `${SURVEY_UNLOCK_KEY_PREFIX}${surveySlug}`;
  const [unlocked, setUnlocked] = useState<boolean>(() => {
    try {
      return sessionStorage.getItem(storageKey) === '1';
    } catch {
      return false;
    }
  });
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const expectedPassword = surveyConfig[surveySlug]?.password ?? '';

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      setError('');
      if (password.trim() === expectedPassword) {
        try {
          sessionStorage.setItem(storageKey, '1');
          setUnlocked(true);
        } catch {
          setUnlocked(true);
        }
      } else {
        setError('Incorrect password. Please try again.');
      }
    },
    [password, expectedPassword, storageKey]
  );

  if (unlocked) {
    return <div className="survey-root">{children}</div>;
  }

  return (
    <div className="survey-root survey-gate">
      <div className="survey-gate-card">
        <div className="survey-gate-org">OARA Youth Innovation Lab</div>
        <h1 className="survey-gate-title">{title}</h1>
        <p className="survey-gate-desc">This survey is password protected. Please enter the access code that was shared with you to continue.</p>
        <form onSubmit={handleSubmit} className="survey-gate-form">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="survey-gate-input"
            autoFocus
            autoComplete="current-password"
          />
          {error && <p className="survey-gate-error">{error}</p>}
          <button type="submit" className="survey-gate-btn">
            Continue
          </button>
        </form>
      </div>
    </div>
  );
};
